import { parseOrRaw } from 'domain/shared/validation'
import { googleCallToActionsResponseSchema } from './schemas'

// parseOrRaw falls through to the raw response on schema mismatch rather than
// breaking the selector.
export function mapGoogleCallToActionsResponse(data) {
  const parsed = parseOrRaw(googleCallToActionsResponseSchema, data)
  return Array.isArray(parsed) ? parsed : []
}
